export const MANAGE_TAGS_AND_FOLDER = {
  SAVE_TO_FOLDER_BUTTON: { key: 'SAVE_TO_FOLDER_BUTTON', value: 'Save to folder' },
  MANAGE_TAGS_BUTTON: { key: 'MANAGE_TAGS_BUTTON', value: 'Manage Tags' },
};